import { AlertTriangle } from 'lucide-react';
import { PROTO } from '@/constants/testIds/healthspan';

export default function ContraindicationBox({ items = [] }) {
  if (!items || items.length === 0) return null;
  return (
    <div data-testid={PROTO.contraindicationBox} className="mt-4 rounded-[var(--radius-sm)] border border-[color:var(--danger)] bg-[color:var(--danger-bg)] p-4">
      <div className="flex items-start gap-2">
        <AlertTriangle className="h-4 w-4 mt-0.5 text-[color:var(--danger)] shrink-0" aria-hidden="true" />
        <div>
          <div className="text-sm font-semibold text-[color:var(--danger)]">Contraindications / cautions</div>
          <ul className="mt-1 text-sm leading-6 list-disc pl-5">
            {items.map((c, i) => (<li key={i}>{c}</li>))}
          </ul>
          <p className="mt-2 text-[11px] text-[color:var(--muted-fg)]">Educational summary only. Confirm safety with a qualified clinician.</p>
        </div>
      </div>
    </div>
  );
}
